import * as actionTypes from './actionTypes';
import { serviceUserList, serviceRefreshToken } from './service';
import { openModal } from '@app/src/commons/modal/state/modals/actions';

const fetchUserListRequest = () => ({
  type: actionTypes.FETCH_USER_LIST_REQUEST
});

const fetchUserListFailure = (errorMessage: string) => ({
  type: actionTypes.FETCH_USER_LIST_FAILURE,
  errorMessage
});

const fetchUserListSuccess = (data: object) => ({
  type: actionTypes.FETCH_USER_LIST_SUCCESS,
  data
});

const fetchGetRefreshToken = () => ({
  type: actionTypes.FETCH_REFRESHTOKEN_REQUEST
});

export const fetchUserList = (values, url): Function => {
  return async dispatch => {
    dispatch(fetchUserListRequest());
    try {
      const data = await serviceUserList.getData(values, url);
      dispatch(fetchUserListSuccess(data));
    } catch (e) {
      if (e.code === 143) {
        dispatch(fetchRefreshToken(values, url));
        return;
      }
      if (e.code === 132) {
        dispatch(openModal('CLOSE_SESSION_MODAL'));
        return;
      }
      dispatch(fetchUserListFailure(e.message));
    }
  };
};

const fetchRefreshToken = (values, url) => {
  return async dispatch => {
    dispatch(fetchGetRefreshToken());
    try {
      const refreshToken = localStorage.getItem('refreshtoken');
      const { data } = await serviceRefreshToken.getData(refreshToken);
      const value = await serviceUserList.getData(values, url, data.accessToken);
      dispatch(fetchUserListSuccess(value));
    } catch (error) {
      dispatch(fetchUserListFailure(error.message));
    }
  }
}
